module.exports = __webpack_public_path__ + "img/github-brands.ec5bc1b3.svg";